import React, { useEffect, useState } from "react";
import { IoIosClose } from "react-icons/io";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import RequestService, { encerramentoTecnico } from "../../services/RequestService";
import MinorRequestDetails from './../molecules/MinorRequestDetails';
import { parseISO, format } from "date-fns";
import StatusRequests from '../../enums/StatusRequests'
import { MdSend } from "react-icons/md";
import { useForm } from "react-hook-form";
import CollectOrderService from "../../services/CollectOrderService";
import { getDescricaoByCod } from "../../enums/TiposGestao";
import { FaExclamationCircle } from "react-icons/fa";



export default function CancelModal({
  isModalOpen,
  setModalOpen,
  requestId,
  isGestao,
  // setTicketCb
}) {
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();

    const [requestObject, setRequestObject] = useState();
    const [hasCollectOrders, setHasCollectOrders] = useState(false);

  useEffect(() => {
    async function fetchRequest() {
      const request = await RequestService.getRequestById(requestId);
      setRequestObject(request);

      // Verifica se há CollectOrders associadas com status específico
      const filter = `?idrequest=${request?.request?.idRequest}`;
      const collectOrdersResult = await CollectOrderService.getCollectOrders(filter);

      const statusValidos = ['ACERTO','ABERTO', 'REPASSE PARA COLETA', 'ROTA DE COLETA', 'TRIAGEM', 'FINALIZADA'];
      const hasValidCollectOrder =
        collectOrdersResult &&
        collectOrdersResult.collectOrders &&
        collectOrdersResult.collectOrders.some(co =>
          statusValidos.includes(co.status)
        );

      setHasCollectOrders(!!hasValidCollectOrder);
    }

    fetchRequest();
  }, [isModalOpen, requestId]);
  

  const onSubmit = async (data) => {
    if (hasCollectOrders || requestObject?.request?.motivoEnvioGestao==='10') {
      // Encerramento técnico
      const body = {
        motivoEncerramento: data.motivoEncerramento,
        manterColetas: data.manterColetas || false,
      };
      try {
        const response = await encerramentoTecnico(requestId, body);
        if (response) {
          toast.success("Solicitação encerrada tecnicamente!");
        } else {
          toast.error("Ops! Não foi possível encerrar!");
        }
      } catch (error) {
        toast.error(error?.message || "Ops! Não foi possível encerrar!");
      }
    } else {
      // Cancelamento normal
      const body = {
        status: "CANCELADO",
        cancelDate: new Date(),
        motivoCancelamento: data.motivoCancelamento,
        retornarQtdOriginal: data.retornarQtdOriginal ? data.retornarQtdOriginal : false,
      };
      try {
        const response = await RequestService.cancelRequest(requestId, body);
        if (response) {
          toast.success("Solicitação cancelada!");
        } else {
          toast.error("Ops! Não foi possível cancelar!");
        }
      } catch (error) {
        toast.error(error?.message || "Ops! Não foi possível cancelar!");
      }
    }
    setModalOpen(false);
  };

  const onClose = () => {
    setModalOpen(!isModalOpen);
  };

  if (isModalOpen) {
    return (
      <div
        className="flex flex-col relative z-10"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>
        <div 
          className="fixed inset-0 z-10 w-screen overflow-y-auto"
          onClick={onClose}
        >
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <div className="flex flex-col max-w-[780px] h-fit pb-4 relative transform rounded-lg bg-white text-left shadow-xl transition-all" onClick={(e) => e.stopPropagation()}>
              <button
                onClick={onClose}
                className="absolute -top-7 -right-7 rounded-full p-1"
              >
                <div className="w-12 h-12 flex bg-gray-200 justify-center items-center rounded-full ms-6">
                  <div className="flex justify-center items-center">
                    <IoIosClose color={"black"} size={32} />
                  </div>
                </div>
              </button>
              <div className="flex flex-col px-4 pt-4 pb-3 text-left gap-2 bg-gray-800 text-white rounded-t-lg">
                <div className="flex gap-2 items-center text-white text-xl font-bold">
                  {((hasCollectOrders || requestObject?.request?.motivoEnvioGestao==='10') || requestObject?.request?.motivoEnvioGestao==='10') ? <><FaExclamationCircle color={'#f87171'} /><div className="text-[#f87171]">ENCERRAMENTO TÉCNICO</div></>: <><MdSend /> CANCELAR SOLICITAÇÃO</>}
                </div>
                <div className="ms-4 flex justify-between">
                  <div className="text-sm">
                    Solicitação nº: {requestObject?.request?.idRequest}
                  </div>
                  <div className="text-sm">
                    Criado em: {requestObject && format(parseISO(requestObject?.request?.createdAt), 'dd/MM/yy HH:mm')}
                  </div>
                  <div className="flex items-center gap-2">
                    Status:
                    <p className="text-sm text-black rounded-lg px-2"
                      style={{ backgroundColor: StatusRequests[requestObject?.request?.status]?.cor }}>
                      {requestObject?.request?.status}
                    </p>
                  </div>
                </div>
              </div>

              {(hasCollectOrders) && 
                <div className="mx-4 mt-4 mb-2 px-4 py-2 rounded bg-yellow-100 border border-yellow-400 text-yellow-800 font-semibold text-sm">
                  Atenção: Esta solicitação possui ordens de coleta associadas.
                </div>
              }

              <MinorRequestDetails request={requestObject?.request} divBoleto={true} />

              {isGestao && (
                <div className="flex flex-col py-2 px-4 mt-1 mx-2 gap-2 bg-red-100 border rounded-md text-xs">
                  <div className="flex flex-col gap-2 w-full">
                    <div className="flex items-start gap-1 w-full">
                      <label className="block text-gray-700 font-bold">Motivo Gestão:</label>
                      <div>{requestObject?.request?.motivoEnvioGestao} - {getDescricaoByCod(requestObject?.request?.motivoEnvioGestao)}</div>
                    </div>
                    <div className="flex items-start gap-1 w-full">
                      <label className="block text-gray-700 font-bold">Última observação:</label>
                      <div>{requestObject?.request?.ultimaObs}</div>
                    </div>
                    {/* Checkbox para marcar encerramento técnico */}
                    {requestObject?.request?.motivoEnvioGestao !== '10' && (
                      <div className="flex items-center gap-2 mt-2">
                        <input
                          type="checkbox"
                          id="marcarEncerramentoTecnico"
                          checked={requestObject?.request?.motivoEnvioGestao === '10'}
                          onChange={async (e) => {
                            if (e.target.checked) {
                              try {
                                await RequestService.updateParcial(requestObject.request._id, { motivoEnvioGestao: '10' });
                                setRequestObject((prev) => ({
                                  ...prev,
                                  request: {
                                    ...prev.request,
                                    motivoEnvioGestao: '10',
                                  },
                                }));
                                toast.success("Marcado para encerramento técnico!");
                              } catch (error) {
                                toast.error("Erro ao marcar para encerramento técnico.");
                              }
                            }
                          }}
                          className="form-checkbox h-4 w-4 text-blue-600"
                        />
                        <label htmlFor="marcarEncerramentoTecnico" className="text-gray-700 font-bold whitespace-nowrap">
                          Marcar para encerramento técnico
                        </label>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* MODAL FORM BEGIN */}
              <div className="flex flex-col mt-6 px-12">
                <div className="w-full relative inline-block text-left">
                  <div className="w-full flex flex-col text-sm">
                    <div className="flex flex-col items-start gap-1 mb-4 w-full">
                      {(hasCollectOrders || requestObject?.request?.motivoEnvioGestao==='10') ? (
                        <>
                          {/* <div className="w-full px-4 py-1 justify-center items-center rounded bg-rose-100 border border-rose-400 text-rose-800 font-semibold text-sm">
                            Encerramento Técnico
                          </div> */}
                          <div className="flex flex-col items-start gap-1 w-full">
                            <label className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">
                              Motivo Encerramento
                            </label>
                            <input
                              type="text"
                              {...register("motivoEncerramento", { required: true })}
                              className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                                ${errors?.motivoEncerramento?.type === "required"
                                  ? " border border-red-500 outline-none ring-0"
                                  : "border border-zinc-500 outline-none ring-0"
                                }
                              `}
                            />
                            {errors?.motivoEncerramento?.type === "required" && (
                              <p className="text-red-500 text-xs ms-2">
                                Campo obrigatório
                              </p>
                            )}
                          </div>
                          <div className="flex items-center gap-2 mt-2">
                            <input
                              type="checkbox"
                              id="manterColetas"
                              {...register("manterColetas")}
                              className="form-checkbox h-4 w-4 text-blue-600"
                            />
                            <label htmlFor="manterColetas" className="text-gray-700 font-bold whitespace-nowrap">
                              Manter ordens de coleta abertas
                            </label>
                          </div>
                          <div className="w-1/5 block text-gray-700 font-bold whitespace-nowrap mt-4">
                            Deseja realmente encerrar tecnicamente esta solicitação?
                          </div>
                          <div className="w-1/5 block text-red-700 italic whitespace-nowrap">
                            Esta ação não pode ser desfeita
                          </div>
                        </>
                      ) : (
                        <>
                            {/* NOVO CHECKBOX PARA isChild */}
                            {requestObject?.request?.isChild === true && (
                              <div className="flex items-center gap-2 mb-2">
                                <input
                                  type="checkbox"
                                  id="retornarQtdOriginal"
                                  {...register("retornarQtdOriginal")}
                                  className="form-checkbox h-4 w-4 text-blue-600"
                                />
                                <label htmlFor="retornarQtdOriginal" className="text-gray-700 whitespace-nowrap">
                                  Retornar a quantidade ao chamado original?
                                </label>
                              </div>
                            )}
                          <div className="flex flex-col items-start gap-1 w-full">
                            <label className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">
                              Motivo Cancelamento
                            </label>
                            <input
                              type="text"
                              {...register("motivoCancelamento", { required: true })}
                              className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                                ${errors?.motivoCancelamento?.type === "required"
                                  ? " border border-red-500 outline-none ring-0"
                                  : "border border-zinc-500 outline-none ring-0"
                                }
                              `}
                            />
                            {errors?.motivoCancelamento?.type === "required" && (
                              <p className="text-red-500 text-xs ms-2">
                                Campo obrigatório
                              </p>
                            )}
                          </div>
                          <div className="w-1/5 block text-gray-700 font-bold whitespace-nowrap mt-4">
                            Deseja realmente cancelar esta solicitação?
                          </div>
                          <div className="w-1/5 block text-red-700 italic whitespace-nowrap">
                            Esta ação não pode ser desfeita
                          </div>
                        </>
                      )}
                    </div>
                    <div className="flex gap-4">
                      <button
                        onClick={() => handleSubmit(onSubmit)()}
                        className="w-full bg-red-400 text-white py-2 px-4 rounded-2xl hover:bg-red-600"
                      >
                        Sim
                      </button>
                      <button
                        onClick={onClose}
                        className="w-full bg-gray-500 text-white py-2 px-4 rounded-2xl hover:bg-gray-600"
                      >
                        Não
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {/* MODAL FORM END */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
